const storeComBarOptions = function storeComBarOptions() {
  return {
    color: ['#FFAE00', '#0095FF'],
    title: {
      show: false,
      textStyle: {
        color: "#888",
        fontSize: 16,
        fontWeight: 'normal',
      },
      text: "暂无数据",
      left: "center",
      top: "260",
    },
    grid: {
      top: '3%',
      left: '2%',
      right: '1%',
      bottom: '6%',
      containLabel: true,
    },
    dataZoom: {
      type: 'slider',
      realtime: true, // 拖动滚动条时是否动态的更新图表数据
      height: 20, // 滚动条高度
      startValue: 0, // 数据窗口范围的起始数值
      endValue: 6,
      show: true,
      handleSize: 0, // 滑动条的 左右2个滑动条的大小
      zoomLock: true,
      bottom: 28, // 下面的距离
      borderColor: "rgba(2,169,241,0)",
      fillerColor: 'rgba(233, 233, 233, 1)',
      showDataShadow: false, // 是否显示数据阴影 默认auto
      showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
      borderRadius: 5,
      filterMode: 'filter',
    },
    xAxis: [{
      type: 'category',
      offset: 25,
      data: [],
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: { // 坐标轴刻度标签的相关设置,x轴换行。
        formatter(value) {
          return (value.length > 6 ? (`${value.slice(0, 6)}...`) : value);
        },
      },
    }],
    yAxis: [{
      show: false,
      type: 'value',
      offset: 15,
    }],
    series: [{
      name: '收款金额',
      type: 'bar',
      barWidth: '15px',
      itemStyle: {
        normal: {
          label: {
            show: true, // 开启显示
            position: 'top', // 在上方显示
            offset: [-56, 6],
            textStyle: { // 数值样式
              color: '#333333',
              fontSize: 14,
            },
            formatter(params) {
              return `${params.data}元`;
            },
          },
        },
      },
      data: [],
    },
    {
      name: '收款笔数',
      type: 'bar',
      barWidth: '15px',
      itemStyle: {
        normal: {
          label: {
            show: true, // 开启显示
            position: 'top', // 在上方显示
            offset: [40, 6],
            textStyle: { // 数值样式
              color: '#333333',
              fontSize: 14,
            },
            formatter(params) {
              return `${params.data}笔`;
            },
          },
        },
      },
      data: [],
    },
    ],
  };
};

export default storeComBarOptions;
